export default __webpack_public_path__ + "static/media/jill-testi.1863c9cc.jpg";